import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { SERVER_API_URL } from 'app/app.constants';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
    private _appUrl: string;

    constructor(private http: HttpClient, private $localStorage: LocalStorageService, private $sessionStorage: SessionStorageService) {}

    getToken() {
        return this.$localStorage.retrieve('authenticationToken') || this.$sessionStorage.retrieve('authenticationToken');
    }

    login(credentials: { username: any; password: any; rememberMe: any; }): Observable<any> {
        const data = {
            username: credentials.username,
            password: credentials.password,
            rememberMe: credentials.rememberMe
        };
        return this.http.post(SERVER_API_URL + 'api/authenticate', data, { observe: 'response' })
          .pipe(
            map(resp => {
              const bearerToken = resp.headers.get('Authorization');
              if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
                const jwt = bearerToken.slice(7, bearerToken.length);
                this.storeAuthenticationToken(jwt, credentials.rememberMe);
                return jwt;
              }
              return null;
            })
          );
    }

    loginWithToken(jwt: any, rememberMe: any) {
        if (jwt) {
            this.storeAuthenticationToken(jwt, rememberMe);
            return Promise.resolve(jwt);
        } else {
            return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
        }
    }

    storeAuthenticationToken(jwt: any, rememberMe: any) {
        if (rememberMe) {
            this.$localStorage.store('authenticationToken', jwt);
        } else {
            this.$sessionStorage.store('authenticationToken', jwt);
        }
    }

    logout(): any {
            this.$localStorage.clear('authenticationToken');
            this.$sessionStorage.clear('authenticationToken');
            this.$localStorage.clear('jhi-authenticationToken');
            this.$sessionStorage.clear('jhi-authenticationToken');
    }

    authorize(isFirstLogin?: boolean): Observable<any> {
        let prefix = 'private/';
        if (isFirstLogin) {
            prefix = 'public/';
        }

        return this.http
            .post(SERVER_API_URL + prefix + 'authorize', null, {
                observe: 'response'
            })
            .pipe(
              map(resp => {
                const bearerToken = resp.headers.get('Authorization');
                if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
                  const jwt = bearerToken.slice(7, bearerToken.length);
                  this.storeAuthenticationToken(jwt, false);
                  return jwt;
                }
                return null;
              })
            );
    }

    organization(): Observable<any> {
        const options: Object = {
            headers: new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8'),
            responseType: 'text',
            observe: 'response'
        };
        return this.http.get<string>(SERVER_API_URL + 'public/organization', options);
    }

    get appUrl(): string {
        return this._appUrl;
    }

    set appUrl(value: string) {
        this._appUrl = value;
    }

    getNotAllowedOrganizationUrl(): Observable<any> {
        const options: Object = {
            headers: new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8'),
            responseType: 'text',
            observe: 'response'
        };
        return this.http.get<string>(SERVER_API_URL + 'public/notallowedorgurl', options);
    }
}
